{
  "status": {
    "thinking": "Nolë is thinking…",
    "waitingForResponse": "Waiting for response…",
    "responseFailed": "The response failed.",
    "writing": "Nolë is writing",
    "errorOccurred": "An error occurred."
  },
  "generationError": {
    "rateLimited": "The model is temporarily rate-limited by its provider. Try again in a moment, or pick another model.",
    "unavailable": "The model's provider is temporarily unavailable. Try again in a moment, or pick another model.",
    "credits": "The AI service is temporarily unavailable. Try again later, or pick another model.",
    "contextTooLong": "This conversation is too long for this model. Start a new chat, or pick a model with a larger context.",
    "unsupported": "This model can't handle this request. Pick another model.",
    "interrupted": "The response was interrupted before it finished. Try again."
  },
  "panel": {
    "untitledChat": "Untitled chat",
    "newChat": "New chat",
    "closePanel": "Close panel"
  },
  "suggestions": {
    "hello": "Hello {{name}}",
    "startTalking": "Start talking to Nolë",
    "intro": "Here are a few ideas to get started.",
    "research": {
      "label": "Research a topic",
      "prompt": "Search the web for the topic below. Then create a BlockNote node on this canvas containing a concise summary and links to the sources. Topic: [topic]"
    },
    "image": {
      "label": "Create an image",
      "prompt": "Create an image node on this canvas and fill in its image-generation prompt based on this idea: [describe the image or invent something if left blank]"
    },
    "projectTracker": {
      "label": "Create a project tracker",
      "prompt": "Create a table node titled “Project tracker” with columns Task (text), Due date (date), and Status (select: Not started, In progress, Done). Add three clearly marked example rows. Then create an AppNode connected to the table that displays the number of tasks in each status as a pie chart."
    },
    "pomodoro": {
      "label": "Create a Pomodoro timer",
      "prompt": "Create an AppNode for a Pomodoro timer with a 25-minute focus session, a 5-minute break, a countdown, and Start, Pause, and Reset controls. Times are saved server-side to persist across refreshes."
    },
    "franceImages": {
      "label": "Show me images of France",
      "prompt": "Create five image nodes, one each for Brittany, Paris, Marseille, Annecy, and Bordeaux. Get the images from the web."
    },
    "onboarding": {
      "label": "Prototype an onboarding flow",
      "prompt": "Create a BlockNote node describing a 3-step onboarding flow for Nolënor. Then create an AppNode prototype of that flow with Back, Next, and Finish controls, and connect it to the spec node."
    }
  },
  "mention": {
    "notFoundTitle": "Node not found ({{nodeId}}): deleted or not on this canvas",
    "titleNotFound": "{{title}} · not found",
    "notFound": "Node not found",
    "node": "Node",
    "clickHint": "{{title}} — click to go to, {{modifier}}+click to open",
    "clickToOpen": "{{title}} — click to open"
  },
  "composer": {
    "answerPlaceholder": "Type your answer to Nolë's question…",
    "dictateHint": "Hold Alt + Ctrl to dictate · click to choose the dictation engine",
    "placeholder": "Ask Nolë, @ to mention a node",
    "mentionListLabel": "Canvas nodes to mention",
    "model": "Model",
    "stop": "Stop",
    "send": "Send message",
    "sendQueued": "Send — added after the current step",
    "sendQueuedHint": "Added to the current response, after the current step"
  },
  "threads": {
    "history": "Conversation history",
    "empty": "No conversations on this canvas",
    "delete": "Delete conversation",
    "deleteError": "Error deleting thread."
  },
  "stats": {
    "contextUsed": "Context used: {{percent}}",
    "threadUsage": "Thread usage",
    "consumed": "Consumed",
    "tokens": "{{tokens}} tk",
    "currentContext": "Current context: {{tokens}} tk",
    "cost": "Cost: {{cost}}"
  },
  "chat": {
    "loadMore": "Load more messages",
    "startConversation": "Start a conversation…",
    "errorBoundary": {
      "title": "Couldn't show this conversation",
      "message": "The messages couldn't be loaded. Try again or reload the page — your work is saved on the server.",
      "retry": "Try again"
    }
  },
  "attachments": {
    "emptyHint": "<kbd>Alt + Click</kbd><rest>to attach a node, a block or a cell</rest>",
    "remove": "Remove attachment",
    "removePosition": "Remove position",
    "position": "Position ({{x}}, {{y}})",
    "attachNode": "Attach node"
  },
  "mic": {
    "starting": "Mic starting…",
    "listening": "Listening…",
    "transcribing": "Transcribing…"
  },
  "voiceProvider": {
    "title": "Dictation engine",
    "mistralHint": "Voxtral 3 Mini · auto language",
    "gladiaHint": "Custom vocabulary · fr/en"
  },
  "quotes": {
    "tooMany_one": "Up to {{count}} comment per message: send it first.",
    "tooMany_other": "Up to {{count}} comments per message: send these first.",
    "noleReply": "Nolë's reply",
    "document": "Document",
    "comment": "Comment",
    "showPassage": "Show the passage",
    "editComment": "Edit the comment",
    "removeComment": "Remove this comment",
    "addComment": "+ Add a comment",
    "addToChat": "Add to the chat",
    "addToChatHint": "Add to the chat (Enter)",
    "formFooter": "Added to Nolë's chat, sent with your next message",
    "commentPlaceholder": "Comment or ask Nolë…",
    "replyFurtherUp": "This reply is further up: load more messages to see it."
  },
  "dividers": {
    "compaction": {
      "text": "Earlier conversation summarized",
      "title": "Nolë now works from a summary of the messages above"
    }
  },
  "subagent": {
    "done": "Background task finished",
    "error": "Background task failed",
    "aborted": "Background task stopped"
  },
  "queued": {
    "withdrawError": "Could not withdraw the message",
    "commentedPassages_one": "{{count}} commented passage",
    "commentedPassages_other": "{{count}} commented passages",
    "remove": "Remove this message",
    "label": "Queued — added after the current step"
  },
  "tools": {
    "viewImage": "View image",
    "listCanvases": "List canvases",
    "exploreCanvas": "Explore canvas",
    "useComputer": "Use its computer",
    "askNetworkAccess": "Ask to visit websites",
    "toolFeedback": "Note for the developers",
    "webSearch": "Web search",
    "openWebPage": "Open web page",
    "createNode": "Create node",
    "updateNode": "Update node",
    "insertBlocks": "Insert blocks",
    "replaceBlock": "Replace block",
    "deleteBlocks": "Delete blocks",
    "editBlockText": "Edit block text",
    "updateBlock": "Update block",
    "insertRows": "Insert rows",
    "updateRows": "Update rows",
    "deleteRows": "Delete rows",
    "updateTableSchema": "Update table schema",
    "setTableView": "Sort / filter table",
    "groupNodes": "Group nodes",
    "moveNodes": "Move / restyle nodes",
    "deleteElements": "Delete",
    "editAppCode": "Edit app code",
    "editTranscript": "Edit transcript",
    "connectNodes": "Connect nodes",
    "updateMemory": "Update memory",
    "loadSkill": "Load skill",
    "runSubAgent": "Run sub-agent"
  },
  "activity": {
    "denied": "Denied.",
    "toolFailed": "The tool reported a failure.",
    "readNodes_one": "read {{count}} node",
    "readNodes_other": "read {{count}} nodes",
    "exploredCanvas": "explored the canvas",
    "canvasSearches_one": "searched the canvas",
    "canvasSearches_other": "ran {{count}} canvas searches",
    "webSearches_one": "searched the web",
    "webSearches_other": "ran {{count}} web searches",
    "openedPages_one": "opened {{count}} page",
    "openedPages_other": "opened {{count}} pages",
    "createdNodes_one": "created {{count}} node",
    "createdNodes_other": "created {{count}} nodes",
    "editedNodes_one": "edited {{count}} node",
    "editedNodes_other": "edited {{count}} nodes",
    "madeEdits_one": "made {{count}} edit",
    "madeEdits_other": "made {{count}} edits",
    "addedConnections_one": "added {{count}} connection",
    "addedConnections_other": "added {{count}} connections",
    "deletedNodes_one": "deleted {{count}} node",
    "deletedNodes_other": "deleted {{count}} nodes",
    "deletedConnections_one": "deleted {{count}} connection",
    "deletedConnections_other": "deleted {{count}} connections",
    "updatedMemory": "updated memory",
    "loadedSkills_one": "loaded a skill",
    "loadedSkills_other": "loaded {{count}} skills",
    "ranSubAgents_one": "ran a sub-agent",
    "ranSubAgents_other": "ran {{count}} sub-agents",
    "usedTools_one": "used {{count}} tool",
    "usedTools_other": "used {{count}} tools",
    "triedActions_one": "tried {{count}} action",
    "triedActions_other": "tried {{count}} actions",
    "thought": "thought",
    "thinking": "Thinking…",
    "thoughtStep": "Thought",
    "steps_one": "{{count}} step",
    "steps_other": "{{count}} steps",
    "failedCount_one": "{{count}} failed",
    "failedCount_other": "{{count}} failed",
    "stopped": "stopped",
    "more_one": "+{{count}} more",
    "more_other": "+{{count}} more",
    "input": "Input",
    "output": "Output",
    "truncated": "… (truncated — copy to get everything)"
  },
  "question": {
    "sendError": "Could not send your answer",
    "skipped": "Skipped",
    "notAnswered": "Not answered.",
    "selectAll": "Select all that apply.",
    "somethingElse": "Something else",
    "yourAnswer": "Your answer",
    "missingAnswer": "Question {{number}} has no answer yet.",
    "orReplyBelow": "Or reply in the chat box below.",
    "skip": "Skip",
    "submit": "Submit",
    "next": "Next",
    "previousQuestion": "Previous question",
    "nextQuestion": "Next question",
    "pager": "{{page}} of {{total}}"
  },
  "tasks": {
    "stopped": "Stopped before finishing.",
    "failed": "Something went wrong.",
    "partial": "Some changes were made before it stopped.",
    "retryError": "Could not retry the task",
    "fullAnswer": "Full answer in the conversation",
    "background_one": "{{count}} task in the background",
    "background_other": "{{count}} tasks in the background",
    "inContext": "In “{{title}}”",
    "dismiss": "Dismiss"
  },
  "markdown": {
    "copyCode": "Copy code"
  },
  "voiceMemo": {
    "discardTitle": "Discard this voice memo?",
    "discardText": "The recording will be lost.",
    "discard": "Discard",
    "record": "Record a voice memo",
    "recordingShow": "Recording — click to show",
    "recordShortcut": "Record a voice memo (R)",
    "recording": "Recording",
    "failed": "Voice memo failed",
    "waitingMic": "Waiting for the microphone…",
    "savingPercent": "Saving… {{percent}}%",
    "hint": "Becomes an audio node on this canvas",
    "hide": "Hide — the recording continues",
    "stopAndSave": "Stop and save",
    "savedElsewhere": "Voice memo saved to the canvas where you recorded it"
  }
}
